import { LAST_ORG_STORAGE_KEY_LEGACY, lastOrgStorageKey } from '@hooks/use-pwa';
import {
  readBrowserPushApi,
  unsubscribePushOnSignOut
} from '~/src/push/browser';

/**
 * Clears Serwist runtime caches and user-scoped PWA localStorage on sign-out
 * so the next session on a shared device does not see cached app shells or org
 * routing hints from the previous user.
 */
export async function clearPwaSessionData(
  userId?: string | null
): Promise<void> {
  if (typeof window === 'undefined') return;

  const api = readBrowserPushApi();
  if (api) {
    await unsubscribePushOnSignOut(api);
  }

  try {
    const cacheNames = await caches.keys();
    await Promise.all(cacheNames.map(name => caches.delete(name)));
  } catch {
    // Cache API unavailable — non-fatal.
  }

  try {
    if (userId) {
      localStorage.removeItem(lastOrgStorageKey(userId));
    }
    localStorage.removeItem(LAST_ORG_STORAGE_KEY_LEGACY);
  } catch {
    // Private browsing / quota — non-fatal.
  }
}
